<template>
    <BCard
        v-if="visible"
        class="guided-unassigned-substances-section mb-1"
    >
        <template #header>
            <div>
                <h5 class="mb-25">
                    {{ translate(
                        'Component(ResearchReviewProcess):unassigned-substances',
                        'Unassigned substances',
                    ) }}
                    <BBadge v-if="items.length" variant="light-warning" class="ml-50">
                        {{ items.length }}
                    </BBadge>
                </h5>
                <p class="text-less-muted mb-0">
                    {{ translate(
                        'Component(ResearchReviewProcess):unassigned-substances-description',
                        'Match or remove substances that are not associated with a selected regulation.',
                    ) }}
                </p>
            </div>
        </template>

        <GuidedRegulationSubstanceRow
            v-for="item in items"
            ref="substanceRows"
            :key="item.rowKey"
            :row-key="item.rowKey"
            :substance-index="item.index"
            :substance="item.substance"
            :summary="item.summary"
            :matching="isHydrating(item)"
            :violations="substanceViolations(item.index)"
            @input="$emit('update-substance', item.index, $event)"
            @select-link="$emit('select-substance-link', item, $event)"
            @remove="$emit('remove-substance', item.index)"
        />

        <BAlert
            v-if="unassignedLinkCount || missingRegulationSubstanceIds.length"
            variant="light-warning"
            show
            class="mb-0 mt-75"
        >
            <div class="alert-body">
                {{ translate(
                    'Component(ResearchReviewProcess):unresolved-substance-links',
                    'Some saved substance matches cannot currently be assigned. They are preserved for review.',
                ) }}
            </div>
        </BAlert>
    </BCard>
</template>

<script>
import {
    BAlert,
    BBadge,
    BCard,
} from 'bootstrap-vue'
import GuidedRegulationSubstanceRow from './GuidedRegulationSubstanceRow.vue'
import { substanceViolationTarget } from '../../validation/symfony-property-path'

export default {
    name: 'GuidedUnassignedSubstancesSection',
    components: {
        BAlert,
        BBadge,
        BCard,
        GuidedRegulationSubstanceRow,
    },
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        unassignedLinkCount: {
            type: Number,
            default: 0,
        },
        missingRegulationSubstanceIds: {
            type: Array,
            default: () => [],
        },
        hydratingIds: {
            type: Array,
            default: () => [],
        },
        violations: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        visible() {
            return !!(
                this.items.length
                || this.unassignedLinkCount
                || this.missingRegulationSubstanceIds.length
            )
        },
    },
    methods: {
        substanceViolations(index) {
            return this.violations.filter(violation => {
                const target = substanceViolationTarget(violation)

                return target && target.index === index
            })
        },
        focusSubstanceViolation(index, field) {
            const rows = Array.isArray(this.$refs.substanceRows)
                ? this.$refs.substanceRows
                : [this.$refs.substanceRows].filter(Boolean)
            const row = rows.find(item => item.substanceIndex === index)

            return row && typeof row.focusViolation === 'function'
                ? row.focusViolation(field)
                : false
        },
        translate(key, fallback) {
            const translation = this.$t(key)

            return translation && translation !== key ? translation : fallback
        },
        isHydrating(item) {
            return !!(item.link && item.link.substanceId
                && this.hydratingIds.includes(Number(item.link.substanceId)))
        },
    },
}
</script>
